import { render } from "./CompanyPageList.vue?vue&type=template&id=09ff5cc1&scoped=true"
import script from "./CompanyPageList.vue?vue&type=script&lang=ts"
export * from "./CompanyPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-09ff5cc1"

export default script